import { COMMENT_KIND } from "applesauce-common/helpers";
import {
  createAddressLoader,
  createEventLoader,
  createEventLoaderForStore,
  createReactionsLoader,
  createTagValueLoader,
} from "applesauce-loaders/loaders";
import { cacheRequest } from "./cache";
import { pool } from "./pool";
import { eventStore } from "./stores";
import { effectiveDefaultRelays, lookupRelays } from "./settings";

export const addressLoader = createAddressLoader(pool, {
  cacheRequest,
  extraRelays: effectiveDefaultRelays,
  eventStore,
  lookupRelays,
});
export const eventLoader = createEventLoader(pool, {
  cacheRequest,
  eventStore,
});
export const reactionsLoader = createReactionsLoader(pool, {
  cacheRequest,
  eventStore,
});
export const commentsLoader = createTagValueLoader(pool, "E", {
  cacheRequest,
  eventStore,
  kinds: [COMMENT_KIND],
});

// Attach loaders to the event store
createEventLoaderForStore(eventStore, pool, {
  cacheRequest,
  extraRelays: effectiveDefaultRelays,
  lookupRelays,
});
